import styled from "styled-components";

export const InputContainer = styled.input`
    width: 100%;
    height: 60px;
    border-radius: 12px;
    border: 1px solid rgba(120, 177, 89, 0.25);
    box-shadow: 0px 4px 24px rgba(120, 177, 89, 0.12);
    padding-left: 20px;
    font-family: "Lexend Deca";
    font-size: 14px;

    ::placeholder {
        color: #9C9C9C;
    }
`;